module.exports = __webpack_public_path__ + "static/img/third3_1_4_active.19410fd3.jpg";